import { render, staticRenderFns } from "./MarkdownEditor.vue?vue&type=template&id=36b0f17a&scoped=true"
import script from "./MarkdownEditor.vue?vue&type=script&lang=ts"
export * from "./MarkdownEditor.vue?vue&type=script&lang=ts"
import style0 from "./MarkdownEditor.vue?vue&type=style&index=0&id=36b0f17a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b0f17a",
  null
  
)

export default component.exports